import ContentInfo from './ContentInfo'

export default ContentInfo
